/* tslint:disable */

declare var Object: any;
export interface TaxSimInterface {
  "id"?: any;
}

export class TaxSim implements TaxSimInterface {
  "id": any;
  constructor(data?: TaxSimInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `TaxSim`.
   */
  public static getModelName() {
    return "TaxSim";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of TaxSim for dynamic purposes.
  **/
  public static factory(data: TaxSimInterface): TaxSim{
    return new TaxSim(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'TaxSim',
      plural: 'TaxSim',
      properties: {
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/TaxSim.ts